var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnlineeducation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_214",
    x: 0,
    y: 0,
    width: 75,
    height: 75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.51
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2392",
    "data-name": "Group 2392",
    transform: "translate(2369.5 -2457.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_213",
    "data-name": "Ellipse 213",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(-2367 2460)",
    fill: "#dc2626"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2369.5, 2457.5)",
    filter: "url(#Ellipse_214)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_214-2",
    "data-name": "Ellipse 214",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(7.5 7.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2391",
    "data-name": "Group 2391",
    transform: "translate(0 -58)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1990",
    "data-name": "Rectangle 1990",
    width: 34,
    height: 34,
    transform: "translate(-2349 2536)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2390",
    "data-name": "Group 2390",
    transform: "translate(-1.904 1.64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Exclusion_1",
    "data-name": "Exclusion 1",
    transform: "translate(-2346.096 2540.36)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31,23H1a1,1,0,0,1-1-1v-1.45a.993.993,0,0,1,.095-.425v0A1.017,1.017,0,0,1,0,19.7V1A1,1,0,0,1,1,0H31a1,1,0,0,1,1,1V19.7a.991.991,0,0,1-.094.423A1.01,1.01,0,0,0,31,19.55H1a1,1,0,0,0-.905.575A1,1,0,0,0,1,20.7H31a1,1,0,0,0,.905-.575.992.992,0,0,1,.095.425V22A1,1,0,0,1,31,23Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 31.0004997253418 22.00040054321289 L 31.00040054321289 22.00040054321289 L 31.0004997253418 21.70000076293945 L 0.9999209642410278 21.70000076293945 L 0.9999002814292908 22.00040054321289 L 31.0004997253418 22.00040054321289 M 31.0004997253418 18.54980087280273 L 31.00040626525879 18.54980087280273 L 31.0004997253418 1.000000238418579 L 1.000000238418579 0.9999002814292908 L 0.9999002814292908 18.54980087280273 L 31.0004997253418 18.54980087280273 M 31.0004997253418 23.00040054321289 L 0.9999002814292908 23.00040054321289 C 0.448550283908844 23.00040054321289 2.716064386731887e-07 22.55184936523438 2.716064386731887e-07 22.0004997253418 L 2.716064386731887e-07 20.55060005187988 C 2.716064386731887e-07 20.40199089050293 0.03182027116417885 20.25888061523438 0.09457027167081833 20.12525939941406 L 0.09365027397871017 20.12721061706543 L 0.09275027364492416 20.1252498626709 C 0.03121027164161205 19.99039077758789 2.716064386731887e-07 19.84735107421875 2.716064386731887e-07 19.70009994506836 L 2.716064386731887e-07 0.9999002814292908 C 2.716064386731887e-07 0.448550283908844 0.448550283908844 2.716064386731887e-07 0.9999002814292908 2.716064386731887e-07 L 31.0004997253418 2.716064386731887e-07 C 31.55184936523438 2.716064386731887e-07 32.00040054321289 0.448550283908844 32.00040054321289 0.9999002814292908 L 32.00040054321289 19.70009994506836 C 32.00040054321289 19.84791946411133 31.96883964538574 19.99032020568848 31.90658950805664 20.12334060668945 C 31.74001121520996 19.77493095397949 31.38505935668945 19.54980087280273 31.0004997253418 19.54980087280273 L 0.9999002814292908 19.54980087280273 C 0.6141102910041809 19.54980087280273 0.2587402760982513 19.77568054199219 0.09457027167081833 20.12525939941406 C 0.2586602568626404 20.47439956665039 0.6133102774620056 20.70000076293945 0.9999002814292908 20.70000076293945 L 31.0004997253418 20.70000076293945 C 31.38607025146484 20.70000076293945 31.74137115478516 20.47439956665039 31.90567970275879 20.12525939941406 C 31.96914100646973 20.26028060913086 32.00040054321289 20.40337944030762 32.00040054321289 20.55060005187988 L 32.00040054321289 22.0004997253418 C 32.00040054321289 22.55184936523438 31.55184936523438 23.00040054321289 31.0004997253418 23.00040054321289 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1989",
    "data-name": "Rectangle 1989",
    width: 10,
    height: 2,
    transform: "translate(-2329.096 2558.36)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineeducation);
export default __webpack_public_path__ + "static/media/onlineeducation.c7cb97fe2c004ae73a534e54043d0777.svg";
export { ForwardRef as ReactComponent };